import {
    FETCH_CLOSE_WORKKARD_OPEN_ACTIVITY_REQUEST_SUCCESS,
    FETCH_CLOSE_WORKKARD_OPEN_DIARIES_REQUEST_SUCCESS,
    FETCH_CLOSE_WORKKARD_NOTIFICATION_REQUEST_SUCCESS,
    CLOSE_WORKKARD_VALIDATION_ERROR_MESSAGE,
    CLOSE_WORKKARD_RESET_STATE,
    CLOSE_WORKKARD_RESET_TAB_STATE
} from '../actions/actionConstants';


const initialState = {
    errorMessage: null,
    activitiesData:{
        count: 0,
        outActCount: 0,
        data: {}
    },
    diariesData: {
        count: 0,
        data: []
    },
    notificationData: {
        count: 0,
        data: []
    }
};

export default function (state = initialState, action) {
    switch (action.type) {
        case FETCH_CLOSE_WORKKARD_OPEN_ACTIVITY_REQUEST_SUCCESS: {
            const activitiesData = {
                count: action.payload.count,
                outActCount: action.payload.outActCount,
                data: action.payload.Data
            }

            return Object.assign(
                {},
                state,
                {
                    activitiesData
                }
            );
        }
        case FETCH_CLOSE_WORKKARD_OPEN_DIARIES_REQUEST_SUCCESS: {
            const diariesData = {
                count: action.payload.count,
                data: action.payload.data
            }

            return Object.assign(
                {},
                state,
                {
                    diariesData
                }
            );
        }

        case FETCH_CLOSE_WORKKARD_NOTIFICATION_REQUEST_SUCCESS: {

            const notificationData = {
                count: action.payload.count,
                data: action.payload.wkUpdate
            }

            return Object.assign(
                {},
                state,
                {
                    notificationData
                }
            );
        }

        case CLOSE_WORKKARD_VALIDATION_ERROR_MESSAGE:
            return Object.assign(
                {},
                state,
                {
                    errorMessage: action.payload
                }
            );

        case CLOSE_WORKKARD_RESET_STATE:
            return initialState;

        case CLOSE_WORKKARD_RESET_TAB_STATE:
            const activitiesData = action.payload
            return Object.assign(
                {}, state, { activitiesData }
            )
        default:
            return state;
    }
}